import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";

const ArticleCard = (props) => {
    const { article } = props

    let history = useHistory()

    const handleClick = () => {
        let language = window.location.pathname.split('/')[1]
        if (language != "pt" && language != "es" && language != "en")
            language = "pt"

        history.push(`/${language}/article-external/${article.id}`)
    }

    return (
        <Grid item sm={12} >
            <a onClick={handleClick} style={{ cursor: 'pointer' }} >
                <Typography variant="h3">{article.title}</Typography>
                <Typography variant="h5">{article.subtitle}</Typography>
                <Typography variant="body2">{article.readingtime}</Typography>
            </a>
            <Divider />
        </Grid>
    )
}

export default ArticleCard